export default function logarithmicCurve(x, maxIn=19000) {
  const min_f = Math.log(1) / Math.log(10),
      max_f = Math.log(maxIn) / Math.log(10),
      range = max_f - min_f,
      y = (Math.log(x) / Math.log(10) - min_f) / range
      
      return Math.min(1,y)
}